import {DrawerProps} from '@mantine/core';
import {FilterForm} from '../forms/FilterForm/FilterForm';
import {PlatformDrawer} from '@flexinet/ui-components';
import {I18n} from '@aws-amplify/core';

export const FilterDrawer = ({
                                 opened,
                                 onClose,
                                 ...rest
                             }: DrawerProps) => {
    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={I18n.get('Filter Usage Events')}
            size="md"
            {...rest}
        >
            <FilterForm
                onApply={() => onClose()}
                onCancel={onClose}
            />
        </PlatformDrawer>
    );
};
